import { useState } from 'react';
import { FaTruckFast, FaUniregistry, FaUserPlus } from "react-icons/fa6";
import logo from "./assets/logos/logo_2.png";
import bg from "./assets/images/bg.png";

// Import des pages séparées
import Tracking from './pages/Tracking';
import Contact from './pages/Contact';
import ClientRegister from './pages/clients/ClientRegister';

function App() {
  // State pour gérer quelle page afficher
  const [currentView, setCurrentView] = useState('search');
  // State pour stocker le numéro de tracking à passer au formulaire de contact
  const [selectedTracking, setSelectedTracking] = useState('');

  // Navigation : Aller vers Contact
  const goToContact = (trackingNum = '') => {
    setSelectedTracking(trackingNum);
    setCurrentView('contact');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Navigation : Retour vers Recherche
  const goToSearch = () => {
    setCurrentView('search');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Navigation : Aller vers Inscription
  const goToRegister = () => {
    setCurrentView('register');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen font-sans selection:bg-blue-500 selection:text-white relative">

      {/* --- IMAGE DE FOND GLOBAL --- */}
      <div className="fixed inset-0 z-0">
        <img
         src={bg}
          alt="Logistics Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/90 via-slate-800/85 to-blue-900/80"></div>
      </div>

      <div className="relative z-10 flex flex-col min-h-screen">

        {/* --- Navbar Global --- */}
        <nav className="bg-white/5 backdrop-blur-md border-b border-white/10 px-4 py-3 sticky top-0 z-50">
          <div className="container mx-auto flex justify-between flex-wrap gap-5 items-center">
            <div className="flex items-center gap-2 cursor-pointer" onClick={goToSearch}>
              {logo ? (
                <img className="w-32 brightness-0 invert" src={logo} alt="Logo" />
              ) : (
                <span className="text-white font-black text-2xl tracking-tighter">Samligne</span>
              )}
            </div>
            <div className='flex items-center gap-2'>
              <a
                href="https://proaccess.samligne-express.com/"
                className="flex items-center gap-2 text-white/90 hover:text-white font-medium transition-colors bg-white/10 hover:bg-white/20 px-4 py-2 rounded-lg text-sm">
                <FaTruckFast className="text-lg" />
                <span>Espace Client</span>
              </a>
              <button
                onClick={goToRegister}
                className="flex items-center gap-2 text-white/90 hover:text-white font-medium transition-colors bg-white/10 hover:bg-white/20 px-4 py-2 rounded-lg text-sm">
                <FaUserPlus className="text-lg" />
                <span>S'inscrire</span>
              </button>
            </div>
          </div>
        </nav>

        {/* --- Contenu Principal (Change selon la vue) --- */}
        <main className="container mx-auto flex-grow flex flex-col items-center justify-start pt-10 md:pt-20">

          {currentView === 'contact' ? (
            <Contact
              onBack={goToSearch}
              trackingNumber={selectedTracking}
            />
          ) : currentView === 'register' ? (
            <ClientRegister
              onBack={goToSearch}
            />
          ) : (
            <Tracking
              onContactRequest={goToContact}
            />
          )}

        </main>

        {/* --- Footer Global --- */}
        <footer className="w-full text-center py-6 text-slate-400 text-sm relative z-10">
          <p>© 2025 Samligne National Express.</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
